import React from 'react';
import { Container, Header, Image } from 'semantic-ui-react';

import VRPForm from './components/VRPForm';
import './App.css';
import 'semantic-ui-css/semantic.min.css';
import PublicSafetyPatch from './static/Public-Safety-Patch.jpg';

const App = () => {
	return (
		<div className="App">
			<Container text style={{ marginTop: '3em', marginBottom: '3em' }}>
				<Image size="small" centered src={PublicSafetyPatch} />
				<Header as="h1">Digital Video Recording Request</Header>
				<p>
					Please fill out the form below to request a digital video for your
					viewing.
				</p>
				<VRPForm />
			</Container>
		</div>
	);
};

export default App;
